import type { Article } from '@/mocks/articles';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '亚洲综合网',
      url: 'https://985huidian.cn',
      logo: 'https://985huidian.cn/logo.png',
      description: '亚洲综合网是专注亚洲地区的综合性信息平台，汇聚亚洲娱乐、财经、科技、生活等全品类内容。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+86-10-8888-6666',
        contactType: 'customer service',
        email: 'contact@985huidian.cn',
      },
      sameAs: [
        'https://weibo.com/asiazhnews',
        'https://twitter.com/asiazhnews',
      ],
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '亚洲综合网',
      url: 'https://985huidian.cn',
      description: '亚洲综合网是专注亚洲地区的综合性信息平台，汇聚亚洲娱乐、财经、科技、生活等全品类内容。',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: 'https://985huidian.cn/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [],
      ...data,
    },
  };

  const schema = schemas[type] || schemas.WebPage;

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
}

export function generateArticleSchema(article: Article) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    image: article.image,
    datePublished: article.date,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    publisher: {
      '@type': 'Organization',
      name: '亚洲综合网',
      logo: {
        '@type': 'ImageObject',
        url: 'https://985huidian.cn/logo.png',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://985huidian.cn/article/${article.id}`,
    },
  };
}